import type { CaseStage } from '../types';

export const MOCK_CASE_STAGES: CaseStage[] = [
  { stage: 'New', count: 128, color: '#2563eb' },
  { stage: 'In Review', count: 86, color: '#7c3aed' },
  { stage: 'Escalated', count: 42, color: '#dc2626' },
  { stage: 'Resolved', count: 214, color: '#16a34a' },
];

export const totalCases = (stages: CaseStage[]): number =>
  stages.reduce((sum, stage) => sum + stage.count, 0);
